import TeacherCourseListPage from "./TeacherCourseListPage";
import TeacherCommunityCoursesPage from "./TeacherCommunityCoursesPage";
import { TeacherTabStrip } from "./TeacherTabStrip";
import { useUrlState } from "./useUrlState";

const TABS = [
  { id: "mine", label: "My courses" },
  { id: "community", label: "Community" },
] as const;

export default function TeacherCoursesPage() {
  const [tab, setTab] = useUrlState("tab", "mine");
  const active = tab === "community" ? "community" : "mine";

  return (
    <div className="teacher-page submissions-dashboard">
      <header className="submissions-hero overview-hero">
        <div className="submissions-hero-text">
          <p className="eyebrow">Teacher · Courses</p>
          <h1 className="teacher-page-title">Courses</h1>
          <p className="teacher-page-lede">
            Reusable lesson paths. Build your own or copy one from the community, then start a cohort.
          </p>
        </div>
      </header>
      <TeacherTabStrip tabs={TABS} active={active} onSelect={setTab} ariaLabel="Course views" />
      {active === "community" ? (
        <TeacherCommunityCoursesPage embedded />
      ) : (
        <TeacherCourseListPage embedded />
      )}
    </div>
  );
}
